export const supportedLanguages = [
  {
    code: "en",
    label: "English",
    nativeLabel: "English",
  },
  {
    code: "it",
    label: "Italiano",
    nativeLabel: "Italiano",
  },
] as const;


export type SupportedLocale =
  (typeof supportedLanguages)[number]["code"];


const STORAGE_KEY = "sorrento-locale";

const DEFAULT_LOCALE: SupportedLocale = "en";


function isBrowser(): boolean {
  return typeof window !== "undefined";
}


export function getInitialLocale(): SupportedLocale {

  if (!isBrowser()) {
    return DEFAULT_LOCALE;
  }


  const storedLocale =
    window.localStorage.getItem(
      STORAGE_KEY
    );


  const isSupportedLocale =
    supportedLanguages.some(
      ({ code }) =>
        code === storedLocale
    );


  if (isSupportedLocale) {
    return storedLocale as SupportedLocale;
  }


  return DEFAULT_LOCALE;

}


export function setStoredLocale(
  locale: SupportedLocale
): void {

  if (!isBrowser()) {
    return;
  }


  window.localStorage.setItem(
    STORAGE_KEY,
    locale
  );

}


export function getSupportedLocales(): SupportedLocale[] {

  return supportedLanguages.map(
    ({ code }) =>
      code
  );

}